import React from 'react';

const TableBody = props => <tbody>{props.children}</tbody>;

export default TableBody;
